import { render, staticRenderFns } from "./PollBarChartV2.vue?vue&type=template&id=b0c4fe96&scoped=true"
import script from "./PollBarChartV2.vue?vue&type=script&lang=js"
export * from "./PollBarChartV2.vue?vue&type=script&lang=js"
import style0 from "./PollBarChartV2.vue?vue&type=style&index=0&id=b0c4fe96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c4fe96",
  null
  
)

export default component.exports